import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { styled } from 'dripsy';
import { useTranslation } from 'react-i18next';

import { Button } from '../common/Button';
import { Separator } from '../common/Separator';
import { TextInput } from '../common/TextInput';
import { parseApiError } from '@utils';
import { useViewerModel } from '@models/Viewer/ViewerModel';
import { ToastService } from '@services';
import { TariffPlanCodeEnum } from '@constants';

const Container = styled(View)({
  flexDirection: 'row',
  alignItems: 'flex-start',
});

const RowCouponFieldContainer = styled(View)({
  flex: 2,
});

const RowCouponButtonContainer = styled(View)({
  flex: 1,
});

type ApplyParamsType = {
  id: number;
  newAmount: string;
  discount: number;
  tariffPlan: TariffPlanCodeEnum;
};

export interface ICouponFormProps {
  onApply(params: ApplyParamsType[]): void;
  isApplied?: boolean;
}

export const CouponForm = observer<ICouponFormProps>(
  ({ onApply, isApplied }) => {
    const [value, setValue] = useState('');
    const viewer = useViewerModel();
    const { t } = useTranslation();

    async function applyCoupon() {
      try {
        const res = await viewer.validateCouponCode.run({
          code: value,
        });

        if (res) {
          onApply(res);
        }
      } catch (error) {
        ToastService.showError(parseApiError(error).message);
      }
    }

    return (
      <Container>
        <RowCouponFieldContainer>
          <TextInput
            value={value}
            onChangeText={setValue}
            placeholder={t('common.couponForm.coupon')}
            maxLength={100}
            disabled={isApplied}
          />
        </RowCouponFieldContainer>
        <Separator vertical />
        <RowCouponButtonContainer>
          <Button
            onPress={applyCoupon}
            isLoading={viewer.validateCouponCode.inProgress}
            disabled={isApplied}
          >
            {t('common.couponForm.apply')}
          </Button>
        </RowCouponButtonContainer>
      </Container>
    );
  },
);
